// extracted by mini-css-extract-plugin
module.exports = {"fullwidth":"div_fullwidth__i8RqT","fullwidth_margin":"div_fullwidth_margin__mmwUC","normal":"div_normal__bNSUV"};